
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88079 4.49681C10.7056 3.76299 12.7352 3.71932 14.5899 4.37397C16.4446 5.02862 17.9971 6.33672 18.9569 8.05343L20.7026 7.07743C19.5054 4.93616 17.5689 3.30456 15.2556 2.48801C12.9423 1.67146 10.4107 1.72593 8.13459 2.64123C5.85852 3.55652 3.99402 5.26991 2.89006 7.46068C1.7861 9.65146 1.51834 12.1695 2.13692 14.5434C2.75549 16.9174 4.21799 18.9845 6.25068 20.358C8.28337 21.7315 10.7469 22.3171 13.1802 22.0053C15.6135 21.6935 17.8498 20.5056 19.4705 18.6639C20.437 17.5657 21.1451 16.2798 21.5593 14.9004L21.8316 15.3542L23.5465 14.3252L21.8427 11.4855L21.3282 10.628L20.4707 11.1425L17.631 12.8463L18.66 14.5613L19.7583 13.9023C19.4519 15.1681 18.842 16.3508 17.9691 17.3427C16.6698 18.8191 14.8769 19.7715 12.926 20.0215C10.9752 20.2715 9.00007 19.802 7.37041 18.7008C5.74074 17.5997 4.56822 15.9424 4.07229 14.0391C3.57637 12.1359 3.79103 10.1171 4.67611 8.3607C5.56119 6.60429 7.05601 5.23063 8.88079 4.49681ZM9.50001 8.00001H14.5L14.219 10.2481C14.0939 11.2489 13.2431 12 12.2344 12C13.2431 12 14.0939 12.7511 14.219 13.7519L14.5 16H9.50001L9.78102 13.7519C9.90613 12.7511 10.7569 12 11.7656 12C10.7569 12 9.90613 11.2489 9.78102 10.2481L9.50001 8.00001Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowredelayFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
